var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isDataUpload)?_c('PermissionsTable',{attrs:{"tableData":_vm.permissionsTable},on:{"changePermission":_vm.changePermission}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }